import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f377595"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "shooting-pin-plan" }
const _hoisted_2 = { class: "shooting-pin-plan__wrapper" }
const _hoisted_3 = ["value", "disabled"]
const _hoisted_4 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Map = _resolveComponent("Map")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("select", {
        value: _ctx.activePlanIndex,
        disabled: _ctx.plans.length === 1,
        class: "form-control",
        onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.callToChangeActivePlanIndex(+$event.target.value)))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.plans, (plan, i) => {
          return (_openBlock(), _createElementBlock("option", {
            key: plan.id,
            value: i
          }, _toDisplayString(plan.title), 9, _hoisted_4))
        }), 128))
      ], 40, _hoisted_3)
    ]),
    (_ctx.activePlan)
      ? (_openBlock(), _createBlock(_component_Map, {
          key: _ctx.mapKey,
          maxZoom: _ctx.activePlan.maxZoom,
          maxResolvedZoom: _ctx.activePlan.maxResolvedZoom,
          width: _ctx.activePlan.picWidth,
          height: _ctx.activePlan.picHeight,
          tilesPath: _ctx.tilesPath,
          tilesExtension: _ctx.activePlan.extension,
          points: _ctx.mapPoints,
          activePointId: _ctx.activePointId,
          class: "shooting-pin-plan__map",
          onChangeActivePoint: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('changeActivePoint', $event))),
          onPointMoved: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('pointMoved', $event)))
        }, null, 8, ["maxZoom", "maxResolvedZoom", "width", "height", "tilesPath", "tilesExtension", "points", "activePointId"]))
      : _createCommentVNode("", true)
  ]))
}